import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import SetupMenu from './SetupMenu';
import WingsDropDown from '../Shared/WingsDropDown';
import SessionsDropDown from "../Shared/SessionsDropDown";
import Pagination from "../General/Pagination";
import { scrollToTop } from '../Shared/ScrollOnTop';

const ManageClasses = () => {


    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [Wing_ID, setWing_ID] = useState("");
    const [SessionID, setSessionId] = useState(localStorage.getItem("DefaultSession"));
    const [listOfLedger, setLedger] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [WingName, setWingName] = useState("");
    const [feeStructureLoading, setFeeStructureLoading] = useState(false);
    const [feeStructureByClass, setFeeStructureByClass] = useState({});
    const [admissionFeeColumns, setAdmissionFeeColumns] = useState([]);
    const [monthlyFeeColumns, setMonthlyFeeColumns] = useState([]);

    const [ClassName, setClassName] = useState("");


    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve individual parameter values
        const WingID = urlParams.get('Wing');

        //console.log(WingID);

        if (WingID) {
            setWing_ID(WingID);
        }


    }, []);

    useEffect(() => {
        document.title = "Manage Classes";

        // Don't make API call if Wing_ID is empty or not selected
        if (!Wing_ID || Wing_ID === "" || Wing_ID === "0") {
            setLedger([]);
            setTotalRecords(0);
            setLoading(false);
            return;
        }

        // Set loading state before API call
        setLoading(true);

        const dashboardParms = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            PageNo: pageNo,
            PageSize: pageSize,
            Wing_Id: Wing_ID,
            SessionID: SessionID
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'WingClass/GetClassesByWingnSessionID',
            headers: {
                'Content-Type': 'application/json'
            },
            data: dashboardParms
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code != 0) {
                    setLedger(response.data.ListofRecords || []);
                    setTotalRecords(response.data.ListofRecords ? response.data.ListofRecords.length : 0);
                }
                else {
                    setLedger([]);
                    setTotalRecords(0);
                }
            })
            .catch(function (error) {
                console.error("Error loading classes:", error);
                setLedger([]);
                setTotalRecords(0);
                toast.error("Error loading classes. Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            })
            .finally(function () {
                // Always set loading to false after API call completes
                setLoading(false);
            });

    }, [Wing_ID, SessionID, pageNo, pageSize, AccessKey, UserID, MemberType]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };


    const renderLedger = () => {

        if (listOfLedger != null && listOfLedger.length > 0) {
            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index}>

                            <td>{item.Class_Id}</td>
                            <td>{item.Class_Code}</td>
                            <td>{item.Class_Short_Name}</td>
                            <td>{item.Class_Name}</td>
                            <td>{item.SelectedWing.Wing_Name}</td>
                            <td>{item.Selected_Session.Session_Name}</td>
                            <td>
                                <ul className="inline-action">
                                    <li><NavLink to={'/Setup/EditClass/' + item.Class_Id} className=" green"><i className="ri-edit-line"></i></NavLink></li>
                                    <li><NavLink
                                        to={`/Setup/ManageSection?Wing_ID=${Wing_ID}&Class_Id=${item.Class_Id}&Session=${item.Selected_Session.Session_Name}`}
                                        className=" blue">
                                        <i className="ri-list-check"></i></NavLink></li>
                                    <li><button onClick={(e) => deleteClass(item.Class_Id)} className="red"><i className="ri-delete-bin-line"></i></button></li>
                                    <li><NavLink to={`/PrintReports/Classwiseattendancesheet/` + item.Class_Id} target="_blank" className="blue"><i className="ri-printer-line"></i></NavLink></li>
                                </ul>
                            </td>
                            <td className="">
                                <div className="dropdown dropdown-table-actions">
                                    <Link href="javascript:;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" className="">
                                        <i className="ri-more-fill"></i>
                                    </Link>
                                    {/* Class_Id=${Class}&FYear=${SelectedYear}&SelectedMonth=${SelectedMonth}&Wing=${WingName}&className=${ClassName} */}
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                        {/* <li><Link to={`/Setup/UpdateSection/${item.Section_ID} `} className="dropdown-item"><i className="ri-edit-line"></i> Edit</Link></li>
                                        <li><Link onClick={(e) => deleteSection(item.Section_ID)} className="red dropdown-item"><i className="ri-delete-bin-line"></i>Delete</Link></li> */}
                                        <li ><Link to={`/PrintReports/SectionWiseClassList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Student List</Link></li>
                                        <li><Link to={`/PrintReports/RPTAwardListClass/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Award List</Link></li>
                                        <li><Link to={`/PrintReports/Classwiseattendancesheet/${item.Class_Id}`} target="_blank" className="dropdown-item" ><i className="ri-printer-line"></i>Print Attendence Sheet</Link></li>
                                        <li><Link to={`/PrintReports/AbsentListClassWise/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Absentee List</Link></li>
                                        <li><Link to={`/PrintReports/PrintBioDataFormsList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print BioData Forms</Link></li>
                                        <li><Link to={`/PrintReports/PrintStudentCardsList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Student Cards</Link></li>

                                        <li><Link to={`/PrintReports/PrintTestPerformaList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Test Performa</Link></li>
                                        <li><Link to={`/PrintReports/PrintOralAssessmentReport1/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Oral Assessment Report 1</Link></li>
                                        <li><Link to={`/PrintReports/PrintOralAssessmentReport1Urdu/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Oral Assessment Report 1 Urdu</Link></li>
                                        <li><Link to={`/PrintReports/PrintOralAssessmentReport2Urdu/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Oral Assessment Report 2 Urdu</Link></li>

                                    </ul>
                                </div>
                            </td>
                        </tr>
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan="7"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }


    const deleteClass = (ID) => {

        // Show a confirmation alert
        const userConfirmed = window.confirm('Are you sure you want to delete this class?');

        if (userConfirmed) {
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                Class_Id: ID
            };

            var api_config = {
                method: 'post',
                url: config.base_url + 'WingClass/DeleteClassByClassID',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };


            axios(api_config)
                .then(function (response) {
                    if (response.data.status_code == 1) {
                        toast.success(response.data.status_message || "Class deleted successfully", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        // Trigger data reload by updating Wing_ID (which will trigger useEffect)
                        setWing_ID(prev => prev);
                    } else {
                        toast.error(response.data.status_message || "Failed to delete class", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                })
                .catch(function (error) {
                    console.error("Error deleting class:", error);
                    toast.error("Error deleting class. Please try again.", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                });
        }

    }


    const formatAmount = (value) => {
        const number = Number(value || 0);
        if (Number.isNaN(number)) return "0";
        return number.toLocaleString();
    };

    const buildFeeStructureRow = (feeList, admissionColumns, monthlyColumns) => {
        const admission = {};
        const monthly = {};

        (admissionColumns || []).forEach((col) => {
            admission[col.Fee_Type_ID] = 0;
        });

        (monthlyColumns || []).forEach((col) => {
            monthly[col.Fee_Type_ID] = 0;
        });

        (feeList || []).forEach((item) => {
            const feeTypeId = item.Fee_Type_ID;
            const annualValue = Number(item.AnnualFee || 0);
            const monthlyValue = Number(item.MonthlyFee || 0);

            if (admission.hasOwnProperty(feeTypeId)) {
                admission[feeTypeId] = annualValue;
            }
            if (monthly.hasOwnProperty(feeTypeId)) {
                monthly[feeTypeId] = monthlyValue;
            }
        });

        const totalAdmission = Object.values(admission).reduce((sum, val) => sum + (Number(val) || 0), 0);
        const totalTuition = Object.values(monthly).reduce((sum, val) => sum + (Number(val) || 0), 0);

        return {
            admission,
            monthly,
            totalAdmission,
            totalTuition,
            netTotal: totalAdmission
        };
    };

    const fetchFeeStructureForClasses = async (classes) => {
        if (!classes || classes.length === 0) {
            setFeeStructureByClass({});
            return;
        }

        setFeeStructureLoading(true);

        try {
            const responses = await Promise.all(
                classes.map((item) => {
                    const data = {
                        AccessKey: AccessKey,
                        UserID: UserID,
                        MemberType: MemberType,
                        pageNo: 1,
                        pageSize: 1000,
                        SchoolID: 1,
                        Class_Id: item.Class_Id
                    };

                    return axios({
                        method: "post",
                        url: config.base_url + "FeeType/GetFeeTypesByClassID",
                        headers: { "Content-Type": "application/json" },
                        data: data
                    }).then((response) => ({
                        classId: item.Class_Id,
                        data: response.data
                    })).catch(() => ({
                        classId: item.Class_Id,
                        data: null
                    }));
                })
            );

            const nextMap = {};
            const admissionMap = new Map();
            const monthlyMap = new Map();
            responses.forEach((item) => {
                const feeList = item.data && item.data.ListofRecords ? item.data.ListofRecords : [];
                feeList.forEach((feeItem) => {
                    const annualValue = Number(feeItem.AnnualFee || 0);
                    const monthlyValue = Number(feeItem.MonthlyFee || 0);

                    if (annualValue > 0) {
                        admissionMap.set(feeItem.Fee_Type_ID, {
                            Fee_Type_ID: feeItem.Fee_Type_ID,
                            Fee_Type_Name: feeItem.Fee_Type_Name
                        });
                    }

                    if (monthlyValue > 0) {
                        monthlyMap.set(feeItem.Fee_Type_ID, {
                            Fee_Type_ID: feeItem.Fee_Type_ID,
                            Fee_Type_Name: feeItem.Fee_Type_Name
                        });
                    }
                });

                nextMap[item.classId] = feeList;
            });

            const admissionColumns = Array.from(admissionMap.values());
            const monthlyColumns = Array.from(monthlyMap.values());

            setAdmissionFeeColumns(admissionColumns);
            setMonthlyFeeColumns(monthlyColumns);
            setFeeStructureByClass(nextMap);
        } finally {
            setFeeStructureLoading(false);
        }
    };

    useEffect(() => {
        if (!listOfLedger || listOfLedger.length === 0) {
            setFeeStructureByClass({});
            setAdmissionFeeColumns([]);
            setMonthlyFeeColumns([]);
            return;
        }

        fetchFeeStructureForClasses(listOfLedger);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listOfLedger, AccessKey, UserID, MemberType]);

    return (
        <>
            <ToastContainer />
            <SetupMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/Setup/SetupDashboard">Setup</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Manage Classes</li>
                                </ol>
                            </nav>
                            <div className="page-title">Manage Classes</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/Setup/AddClass" className="button button-white button-icon">
                                    Add Class
                                    <i className="ri-add-line"></i>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">
                    <div className="card mb-2">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Select Session:</label>
                                        <select 
                                            className="form-select" 
                                            name="SessionId" 
                                            value={SessionID || "0"}
                                            onChange={(e) => {
                                                setSessionId(e.target.value);
                                                // Reset to first page when session changes
                                                setPageNo(1);
                                            }}>
                                            <option value="0">---All---</option>
                                            <SessionsDropDown selectedSession={SessionID} />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Select Wing:</label>
                                        <select
                                            onChange={(e) => {
                                                const newWingId = e.target.value;
                                                setWing_ID(newWingId);
                                                const selectedText = e.target.options[e.target.selectedIndex].text;
                                                setWingName(selectedText);
                                                // Reset to first page when wing changes
                                                setPageNo(1);
                                            }}
                                            value={Wing_ID || ""}
                                            className="form-select" required>
                                            <option value="">Please Select</option>
                                            <WingsDropDown selectedWingId={Wing_ID} />
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="counting mt-4 text-end">
                                        <span className="">{totalRecords} </span> Records Found!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body table-wrap">
                            <table className="table table-theme table-hover">
                                <thead>
                                    <tr>
                                        <th>
                                            Class ID
                                        </th>
                                        <th>
                                            Class Code
                                        </th>
                                        <th>
                                            Class Short Name
                                        </th>
                                        <th>
                                            Class Name
                                        </th>
                                        <th>
                                            Wing Name
                                        </th>
                                        <th>
                                            Session
                                        </th>
                                        <th className="text-center">Action</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        loading ?
                                            <tr>
                                                <td className="text-center" colSpan="7">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                            :
                                            <>
                                                {renderLedger()}
                                            </>

                                    }
                                </tbody>
                            </table>
                            {
                                totalRecords > pageSize &&
                                <div className="pagination-wrap">

                                    <div className="row align-items-center">
                                        <div className="col-md-2 form_default">
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                <div className="form-group">
                                                    <select className="form-select"
                                                        style={{ width: "100px" }}
                                                        onChange={(e) => {
                                                            setPageNo(1);
                                                            setPageSize(parseInt(e.target.value));


                                                        }}>
                                                        <option value="10" selected>10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="500">500</option>


                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <Pagination
                                            pageNo={pageNo}
                                            pageSize={pageSize}
                                            totalRecords={totalRecords}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>

                            }

                        </div>
                    </div>
                    <div className="card mt-md-3">
                        <div className="card-body">
                            <div className="row justify-content-end">
                                <div className="col-md-2">
                                    <NavLink
                                        target="_blank"
                                        to={`/Setup/PrintManageClasses/?wing_id=${Wing_ID}`}
                                        className="button button-primary w-100"
                                    >
                                        Print This Report
                                    </NavLink>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="card mt-md-3">
                        <div className="card-body">
                            <div className="card-title mb-3">Class Fee Structure</div>
                            <div className="table-responsive">
                                <table className="table table-theme table-bordered">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2">Classes</th>
                                            <th colSpan={Math.max(admissionFeeColumns.length, 1)} className="text-center">Admission Fee</th>
                                            <th colSpan={Math.max(monthlyFeeColumns.length, 1)} className="text-center">Monthly Charges</th>
                                            <th rowSpan="2" className="text-center">Total Tuition Fee</th>
                                            <th rowSpan="2" className="text-center">Net Total Adm. Fee</th>
                                        </tr>
                                        <tr>
                                            {admissionFeeColumns.length > 0 ? (
                                                admissionFeeColumns.map((col) => (
                                                    <th key={`admission-col-${col.Fee_Type_ID}`} className="text-center">
                                                        {col.Fee_Type_Name}
                                                    </th>
                                                ))
                                            ) : (
                                                <th className="text-center">Admission Fee</th>
                                            )}
                                            {monthlyFeeColumns.length > 0 ? (
                                                monthlyFeeColumns.map((col) => (
                                                    <th key={`monthly-col-${col.Fee_Type_ID}`} className="text-center">
                                                        {col.Fee_Type_Name}
                                                    </th>
                                                ))
                                            ) : (
                                                <th className="text-center">Monthly Charges</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {feeStructureLoading ? (
                                            <tr>
                                                <td colSpan="14" className="text-center">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                        ) : listOfLedger && listOfLedger.length > 0 ? (
                                            listOfLedger.map((item) => {
                                                const feeList = feeStructureByClass[item.Class_Id] || [];
                                                const row = buildFeeStructureRow(feeList, admissionFeeColumns, monthlyFeeColumns);
                                                return (
                                                    <tr key={`fee-structure-${item.Class_Id}`}>
                                                        <td>{item.Class_Name}</td>
                                                        {admissionFeeColumns.length > 0 ? (
                                                            admissionFeeColumns.map((col) => (
                                                                <td key={`admission-${item.Class_Id}-${col.Fee_Type_ID}`} className="text-end">
                                                                    {formatAmount(row.admission[col.Fee_Type_ID])}
                                                                </td>
                                                            ))
                                                        ) : (
                                                            <td className="text-end">{formatAmount(row.totalAdmission)}</td>
                                                        )}
                                                        {monthlyFeeColumns.length > 0 ? (
                                                            monthlyFeeColumns.map((col) => (
                                                                <td key={`monthly-${item.Class_Id}-${col.Fee_Type_ID}`} className="text-end">
                                                                    {formatAmount(row.monthly[col.Fee_Type_ID])}
                                                                </td>
                                                            ))
                                                        ) : (
                                                            <td className="text-end">{formatAmount(row.totalTuition)}</td>
                                                        )}
                                                        <td className="text-end">{formatAmount(row.totalTuition)}</td>
                                                        <td className="text-end">{formatAmount(row.netTotal)}</td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="14" className="text-center">
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ManageClasses;
